import { useEffect, useState } from "react";
import { getUserBalance } from "../../services/balance";
import { useMediaQuery } from "react-responsive";

export default function TotalAssetsCommodityMobile() {
  const [goldTransactionAssets, setGoldTransactionsAssets] = useState(null);
  const [silverTransactionAssets, setSilverTransactionsAssets] = useState(null);
  const [transations, setTransactions] = useState([]);
  const isTabletOrfirst = useMediaQuery({ query: "(max-width: 768px)" });
  useEffect(() => {
    getUserBalance(1).then(({ data }) => {
      const result = [];
      if (data && data.data) {
        const isBalanceExists = result.find(
          (el) => el.id == "1" || el.id == "6"
        );
        if (!isBalanceExists) {
          result.push({
            id: "1",
            label: "موجودی تومانی",
            amount: data.data.cash_balance,
            color: "#ffffff",
          });
          result.push({
            id: "2",
            label: "تومان بلوکه",
            amount: data.data.useless_cash_amount,
            color: "#ffffff",
          });
          setTransactions(result);
        }
      }
    });
  }, [isTabletOrfirst]);
  useEffect(() => {
    getUserBalance(1).then(({ data }) => {
      if (data && data.data) {
        setGoldTransactionsAssets(data.data);
      }
    });
    getUserBalance(2).then(({ data }) => {
      if (data && data.data) {
        setSilverTransactionsAssets(data.data);
      }
    });
  }, []);
  return (
    <div>
      <div className="scroll">
        <div className="info-box-wrapper-mobile">
          {transations.map((item) => (
            <div className={"info-box-mobile blue-item-box"}>
              <div
                className="price-items bigger-items-amount"
                style={{
                  color: `${item.color}`,
                }}
              >
                {new Intl.NumberFormat("fa", {
                  maximumFractionDigits: 3,
                }).format(item.amount)}{" "}
                {item.id !== "1" && item.id !== "6"
                  ? " گرم"
                  : item.id === "5" || item.id === "10"
                  ? " زرینو"
                  : ""}
              </div>
              <span
                style={{
                  color: `${item.color}`,
                }}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="gold-transaction-assets">
        <div>سود و زیان :</div>
        <div
          className={
            !isNaN(silverTransactionAssets?.total_profit) &&
            silverTransactionAssets?.total_profit > 0
              ? "green-color"
              : "red-color"
          }
        >
          {isNaN(goldTransactionAssets?.total_profit)
            ? new Intl.NumberFormat("fa", {
                maximumFractionDigits: 0,
              }).format(0)
            : new Intl.NumberFormat("fa", {
                maximumFractionDigits: 0,
              }).format(goldTransactionAssets?.total_profit)}
        </div>
      </div>
    </div>
  );
}
